var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 119,
    viewBox: "0 0 125 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.052 70.4214C68.8926 60.6953 55.2997 103.507 52.4041 117.072C52.2551 117.685 52.1573 118.24 52.0665 118.755C52.1527 118.266 52.2155 117.678 52.3249 117.058C54.2194 103.303 56.0863 58.4372 0.92677 48.7111C56.0863 58.4372 69.6793 15.6257 72.6036 2.05206C72.713 1.43155 72.855 0.857626 72.9411 0.369138C72.8504 0.88403 72.7526 1.43853 72.6828 2.06603C70.7619 15.8166 68.8926 60.6953 124.052 70.4214Z",
    fill: "url(#paint0_linear_2009_4116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2009_4116",
    x1: -339.524,
    y1: 354.472,
    x2: 85.2552,
    y2: 42.8617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue-star.9839d2bfd3e18690decec6955684ead0.svg";
export { ForwardRef as ReactComponent };